import ProposalSettingsDC from '../proposalSettings/ProposalSettingsDC';
import { DISCOUNT_TYPES } from '../proposal/ProposalDC';

export const enum PROFORMA_INVOICE_STATUS {
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  FULLY_PAID = 'FULLY_PAID',
}

export const enum PAID_STATUS_SOURCE {
  MANUAL = 'manual',
  PAYMENTS = 'payments',
}

export interface ProformaInvoiceItemDC {
  order: number;
  description: string | null;
  qty: number;
  amount: number;
}

export default interface ProformaInvoiceDC {
  uuid: string;
  workspace_id: string | null;
  invoice_id: string | null;
  price_proposal_id: string | null;
  number: number | null;
  price_proposal_reference: string | null;
  contact_name: string | null;
  contact_id: string | null;
  title: string | null;
  subtotal_price: number | null;
  price_with_discount: number | null;
  tax_value: number | null;
  price_with_tax: number | null;
  description: string | null;
  discount_type: DISCOUNT_TYPES | null;
  discount_amount: number | null;
  items: ProformaInvoiceItemDC[] | null;
  settings: ProposalSettingsDC | null;
  paid_status: PROFORMA_INVOICE_STATUS | null;
  created_at: number | null;
  updated_at: number | null;
  due_date: number | null;
  created_by: string | null;
  updated_by: string | null;
  override_pp_fields: boolean | null;
  override_settings: boolean | null;
  // Server-owned (LAE-752): set when the linked quote was signed with content
  // that differs from this invoice; unix seconds. Absent on older backends.
  review_required_at?: number | null;
  // Server-owned (LAE-766); absent on older backends.
  paid_status_source?: PAID_STATUS_SOURCE | null;
  total_paid?: number | null;
  balance_due?: number | null;
}
